import React from 'react'

const Logo = () => <div><img id="logo" src="logo.png" /></div>

export default Logo